import { TreeNodeRenderFunction } from '@/components/shared/Tree/types';
import { TreeStore } from '@/stores/local/shared/TreeStore';

import Folder from './Folder';

export const renderNode: TreeNodeRenderFunction = (store: TreeStore) => {
  if (!store.data || store.data.type !== 'folder') {
    return null;
  }

  return <Folder key={store.data.id} store={store} model={store.data} />;
};
